// /* global $crisp */
import React from 'react'
import PropTypes from 'prop-types'
import { Transition, Menu } from '@headlessui/react'
import { useAuthService } from 'theme/services/auth/auth-service'
import { navigate, Link, graphql, useStaticQuery } from 'gatsby'

function ProfileMenu({ theme }) {
  const authService = useAuthService()
  const authenticated = authService.authenticated
  const user = authService.user
  const data = useStaticQuery(query)
  const UXDXLogo = data?.file?.childImageSharp?.original?.src ?? ''

  const handleSignOut = (e) => {
    e.preventDefault()
    authService.logout()
    navigate('/')
  }

  const openChat = (e) => {
    e.preventDefault()
    let $crisp
    if (typeof window !== 'undefined') {
      $crisp = window.$crisp
    }

    if (!$crisp) {
      return
    }

    $crisp.push(['do', 'chat:open'])
    const textarea = document.getElementsByClassName('cc-pjpe')[0]
    // setTimeout(function () {
    //   textarea.focus()
    // }, 0)
  }

  const getName = (user) => {
    return user && `${user.firstName} ${user.lastName}`
  }

  return (
    <>
      {/* <Chat theme={theme} /> */}

      {!authenticated && (
        <span
          className={`${
            authenticated ? 'hidden' : 'block'
          } inline-flex rounded-md shadow-sm justify-end ml-6`}
        >
          <Link
            data-cy="header-login-link"
            to="/login"
            className={`text-sm h-6 ml-3 lg:ml-0 whitespace-nowrap border-2 inline-flex items-center justify-center px-2 border border-transparent rounded focus:outline-none transition ease-in-out duration-150
              ${
                theme === 'light'
                  ? 'text-gray-100 border-gray-100 hover:bg-gray-700 hover:text-white'
                  : 'text-gray-100 border-gray-100 hover:bg-gray-700 hover:text-white'
              }`}
          >
            Sign In
          </Link>
        </span>
      )}
      {authenticated && (
        <div className={`${authenticated ? 'flex' : 'hidden'} content-start justify-end max-w-12 ml-2`}>
          <div className="relative inline-block text-left">
            <Menu>
              {({ open }) => (
                <>
                  <span className="rounded-full">
                    <Menu.Button
                      id="header-profile-link"
                      data-cy="header-profile-link"
                      className="inline-flex justify-end max-w-12 px-2 transition duration-50 ease-in-out hover:text-white focus:outline-none focus:ring-white"
                    >
                      {/* <span className='text-sm truncate mr-1 max-w-full'>{getName(user)}</span> */}
                      <div className="relative">
                        <div className="absolute inline-flex items-center justify-center h-6 w-6 bg-gray-100 rounded-full">
                          <span className="font-medium leading-none text-gray-700">
                            {getName()?.charAt(0)}
                          </span>
                        </div>
                        <div className="relative inline-flex items-center justify-center h-6 w-6">
                          {user && (
                            <img
                              className="h-6 w-6 rounded-full"
                              src={user.photoURL || UXDXLogo}
                              alt="Profile"
                            />
                          )}
                        </div>
                      </div>
                    </Menu.Button>
                  </span>

                  <Transition
                    show={open}
                    enter="transition ease-out duration-100"
                    enterFrom="transform opacity-0 scale-95"
                    enterTo="transform opacity-100 scale-100"
                    leave="transition ease-in duration-75"
                    leaveFrom="transform opacity-100 scale-100"
                    leaveTo="transform opacity-0 scale-95"
                  >
                    <Menu.Items
                      static
                      className="absolute z-40 right-0 w-56 mt-1 origin-top-right bg-white border border-gray-200 divide-y divide-gray-100 rounded-md shadow-lg outline-none"
                    >
                      <div className="px-4 py-3">
                        <p className="text-sm leading-5 text-gray-700">Signed in as</p>
                        <p className="text-sm font-medium leading-5 text-gray-900 truncate">
                          {user && user.email}
                        </p>
                      </div>

                      <div className="py-1">
                        <Menu.Item>
                          {({ active }) => (
                            <Link
                              to="/account"
                              className={`${
                                active ? 'bg-gray-100 text-gray-900' : 'text-gray-700'
                              } flex justify-between w-full px-4 py-2 text-sm leading-5 text-left`}
                            >
                              Your Profile
                            </Link>
                          )}
                        </Menu.Item>
                        {/* <Menu.Item>
                          {({ active }) => (
                            <Link
                              to="/account/scan"
                              className={`${
                                active ? 'bg-gray-100 text-gray-900' : 'text-gray-700'
                              } flex justify-between w-full px-4 py-2 text-sm leading-5 text-left`}
                            >
                              Scan &amp; Connect
                            </Link>
                          )}
                        </Menu.Item> */}
                        <Menu.Item>
                          {({ active }) => (
                            <a
                              href="/"
                              onClick={openChat}
                              className={`${
                                active ? 'bg-gray-100 text-gray-900' : 'text-gray-700'
                              } flex justify-between w-full px-4 py-2 text-sm leading-5 text-left`}
                            >
                              Chat with Us
                            </a>
                          )}
                        </Menu.Item>
                        {user?.isTestUser && (
                          // Hidden functionality just for E2E tests
                          <>
                            <Menu.Item>
                              <button
                                data-cy="header-increase-test-sessions-limit-button"
                                onClick={() => authService.setTestUserSessionLimit(3)}
                                className="bg-gray-100 text-gray-900 flex justify-between w-full px-4 py-2 text-sm leading-5 text-left"
                              >
                                Increase user session limit (E2E test)
                              </button>
                            </Menu.Item>
                            <Menu.Item>
                              <button
                                data-cy="header-reset-test-sessions-button"
                                onClick={() => authService.resetTestUserSessions()}
                                className="bg-gray-100 text-gray-900 flex justify-between w-full px-4 py-2 text-sm leading-5 text-left"
                              >
                                Reset test user (E2E test)
                              </button>
                            </Menu.Item>
                          </>
                        )}
                      </div>
                      <div className="py-1">
                        <Menu.Item>
                          {({ active }) => (
                            <a
                              href="/"
                              data-cy="header-logout-link"
                              onClick={handleSignOut}
                              className={`${
                                active ? 'bg-gray-100 text-gray-900' : 'text-gray-700'
                              } flex justify-between w-full px-4 py-2 text-sm leading-5 text-left`}
                            >
                              Sign out
                            </a>
                          )}
                        </Menu.Item>
                      </div>
                    </Menu.Items>
                  </Transition>
                </>
              )}
            </Menu>
          </div>
        </div>
      )}
    </>
  )
}

const query = graphql`
  {
    file(name: { eq: "uxdx-icon" }) {
      childImageSharp {
        original {
          src
        }
      }
    }
  }
`

ProfileMenu.propTypes = {
  theme: PropTypes.string,
}

export default ProfileMenu
